<!-- <template>
	<div :class="['box--form', col, { error: isError }, { 'checkbox-input': inputType === 'checkbox' }]">
		<label :for="inputId" :class="{ required: isRequired }">{{ label }}</label>
		<input 
			@input="applyMask($event.target.value, mask)" 
			:max="valorMax" 
			:type="inputType" 
			:name="inputId" 
			:id="inputId" 
			:placeholder="placeholder" 
			:disabled="isDisabled" 
			v-model="formatedValue"
			:value="formatedValue">
		<span v-show="isError" class="alertErro"><Icons name="exclamation"/> {{messageError}}</span>
	</div>
</template> -->
<!-- OLD -->

<template>
	<div
		:class="['box--form', col, { error: isError || isErrorSecondary }, { 'checkbox-input': inputType === 'checkbox', 'is-disabled': isDisabled }]">
		<label :for="inputId" :class="{ required: isRequired }" v-if="showLabel">{{ label }}</label>
		<div class="input-wrapper">
			<input v-bind="{ 'data-qa': $attrs['data-qa'] }" @input="applyMask($event.target.value, mask)" :max="valorMax" :type="inputType" :name="inputId"
				:id="inputId" :placeholder="placeholder" :disabled="isDisabled" v-model="formatedValue"
				:maxlength="maxlength" :autocomplete="autocomplete" :pattern="pattern"
				@focus="$emit('focus', $event)" @blur="$emit('blur', $event)">
			<!-- Adiciona o slot aqui -->
			<slot></slot>
		</div>
		<span v-show="isError" class="alertErro" v-bind="{ 'data-qa': errorDataQa }">
			<Icons name="exclamation" /> {{ messageError }}
		</span>
		<span v-show="isErrorSecondary" class="alertErro" v-bind="{ 'data-qa': secondaryErrorDataQa }">
			<Icons name="exclamation" /> {{ messageErrorSecondary }}
		</span>
	</div>
</template>


<!-- @input="$emit('update:modelValue', $event.target.value)" -->
<script>
import Icons from '@/components/Icons.vue';
// :value="modelValue"
export default {
	components: {
		Icons
	},
	data() {
		return {
			formatedValue: "",

			// origValue: ""
		}

	},
	created() {
		this.formatedValue = this.modelValue
		this.applyMask(this.formatedValue, this.mask)
	},
	watch: {
		modelValue(newValue) {
			this.formatedValue = newValue;
			this.applyMask(this.formatedValue, this.mask)
		}
	},
	computed: {
		errorDataQa() {
			const selector = this.$attrs['data-qa']
			return typeof selector === 'string' ? `${selector.replace(/-input$/, '')}-error` : undefined
		},
		secondaryErrorDataQa() {
			const selector = this.$attrs['data-qa']
			return typeof selector === 'string' ? `${selector.replace(/-input$/, '')}-secondary-error` : undefined
		}
	},
	methods: {
		applyMask(valor, mascara) {
			if (!mascara) {
				if (this.lettersOnly) {
					valor = String(valor ?? '').replace(/[^\p{L}\s'-]/gu, '')
					this.formatedValue = valor
				}
				this.$emit('update:modelValue', valor);
				return;
			}

			if (!valor) {
				this.$emit('update:modelValue', '');
				return;
			}
			
			let valorLimpo = String(valor).replace(/\D/g, ''); // Remove tudo que não é dígito

			let valorMascarado = '';
			let indiceMascara = 0;
			let indiceValor = 0;

			// Itera até que todos os dígitos do valor sejam consumidos ou a máscara seja totalmente percorrida
			while (indiceValor < valorLimpo.length && indiceMascara < mascara.length) {
				if (mascara[indiceMascara] === '#') {
					valorMascarado += valorLimpo[indiceValor++];
				} else {
					// Garante que caracteres de máscara sejam adicionados desde o início
					valorMascarado += mascara[indiceMascara];
				}
				indiceMascara++;
			}

			this.formatedValue = valorMascarado
			this.$emit('update:modelValue', valorMascarado.replace(/\D/g, ''));
			// Retorna o valor com a máscara aplicada até onde foi possível, sem adicionar extras no final
			// return valorMascarado;
		}
	},
	props: {
		modelValue: String || Boolean || Array || Number,
		placeholder: {
			type: String,
			required: false,
		},
		label: {
			type: String,
			required: true,
		},
		inputId: {
			type: String,
			required: true,
		},
		inputType: {
			type: String,
			default: 'text',
		},
		isRequired: {
			type: Boolean,
			default: false,
		},
		col: {
			type: String,
			default: '',
		},
		isError: {
			type: Boolean,
			default: false,
		},
		isErrorSecondary: {
			type: Boolean,
			default: false,
		},
		isDisabled: {
			type: Boolean,
			default: false,
		},
		mask: String,
		messageError: String,
		messageErrorSecondary: {
			type: String,
			default: null
		},
		valorMax: String,
		maxlength: {
			type: [String, Number],
			default: null, // Define o valor padrão como `null` caso não seja passado
		},
		autocomplete: {
			type: String,
			default: null, // Define o valor padrão como `null` caso não seja passado
		},
		showLabel: {
			type: Boolean,
			default: true
		},
		pattern: {
			type: String,
			default: null
		},
		lettersOnly: {
			type: Boolean,
			default: false
		},
	},
};
</script>
